export const normalizeUrl = (input: string): string => {
  let trimmed = input.trim();
  if (!trimmed) return '';
  if (!/^https?:\/\//i.test(trimmed)) {
    trimmed = 'https://' + trimmed;
  }
  return trimmed;
};

export const isValidUrl = (input: string): boolean => {
  try {
    const url = new URL(input);
    const hostname = url.hostname;

    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;
    const localhostRegex = /^(localhost|127\.0\.0\.1|192\.\d+\.\d+\.\d+)$/;

    return domainRegex.test(hostname) || localhostRegex.test(hostname);
  } catch {
    return false;
  }
};
